import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCoupleStory = loadable(() => import(/* webpackChunkName: "content/guest/widgets/coupleStory" */ './CoupleStory'), 'CoupleStory');
